// Textos propis de la pàgina "bodas" per idioma (Bodas.jsx).

const textos = {
    es: {
        heroImageAlt: "Bodas en el Hotel Camprodon",
        heroSmallTitle: "La boda de tus sueños en Camprodón",
        heroTitle: "Bodas en el Hotel Camprodon",
        presentationSmallTitle: "Tu boda en Camprodón",
        presentationTitle: "Hotel para bodas",
        presentationContent: <>{"El Hotel Camprodon te ofrece un marco incomparable para tu boda. Rodeado de naturaleza y situado en un edificio histórico impregnado de romanticismo, "}<strong>vuestro día será tal y como lo habéis soñado</strong>.</>,
        fullSliderImgAlt: "Hotel para bodas",
        fullSliderImgAlt2: "Hotel para bodas",
        fullSliderImgAlt3: "Hotel para bodas",
        fullSliderImgAlt4: "Hotel para bodas",
        sectionHeadSubtitle: "Celebra la boda de tus sueños",
        sectionHeadTitle: "Bodas en el Hotel Camprodon",
        sectionHeadTexts: "El amplio jardín nos permite organizar vuestra ceremonia al aire libre, así como servir los aperitivos, que también podemos servirlo a la terraza del lado del río. Podréis escoger entre varios menús de boda, y escoger el salón que más os convenga, con capacidad de hasta 250 personas.",
        sectionHeadTexts2: "En el Hotel Camprodon podréis organizar vuestra ceremonia civil oficial, ya que disponemos del libro civil del Ayuntamiento para realizarlo.",
        formTitle: "¿Quieres celebrar tu boda en el Hotel Camprodon?",
        formContent: "Rellena este formulario y envíanos tu solicitud. Nos pondremos en contacto contigo a la mayor brevedad posible.",
        languageValue: "es",
        checkboxHref: "/politica-de-privacidad",
    },
    ca: {
        heroImageAlt: "Casaments a l'Hotel Camprodon",
        heroSmallTitle: "El casament dels teus somnis a Camprodon",
        heroTitle: "Casaments a l'Hotel Camprodon",
        presentationSmallTitle: "El teu casament a Camprodon",
        presentationTitle: "Hotel per a casaments",
        presentationContent: <>{"L’Hotel Camprodon t’ofereix un marc incomparable per al teu casament. Envoltat de natura, i situat en un edifici històric impregnat de romanticisme, "}<strong>el vostre dia serà tal com l’havíeu somniat</strong>.</>,
        fullSliderImgAlt: "Hotel per a casaments",
        fullSliderImgAlt2: "Hotel per a casaments",
        fullSliderImgAlt3: "Hotel per a casaments",
        fullSliderImgAlt4: "Hotel per a casaments",
        sectionHeadSubtitle: "Celebra el casament dels teus somnis",
        sectionHeadTitle: "Casaments a l'Hotel Camprodon",
        sectionHeadTexts: "L’ampli jardí ens permet organitzar la vostra cerimònia a l’aire lliure, així com servir-hi els aperitius, que també podem servir a les terrasses del costat del riu. Podreu triar entre diversos menús de casament, i triar el saló que més us agradi per fer el banquet, amb capacitat fins a 250 persones.",
        sectionHeadTexts2: "A l’Hotel Camprodon podreu organitzar la vostra cerimònia civil oficial, ja que disposem del llibre civil de l’Ajuntament per fer-ho.",
        formTitle: "Vols celebrar el teu casament a l'Hotel Camprodon?",
        formContent: "Omple aquest formulari i envia'ns la teva sol·licitud. Ens posarem en contacte amb tu com més aviat millor.",
        languageValue: "ca",
        checkboxHref: "/ca/politica-de-privacitat",
    },
    en: {
        heroImageAlt: "Weddings at Hotel Camprodon",
        heroSmallTitle: "The wedding of your dreams in Camprodon",
        heroTitle: "Weddings at Hotel Camprodon",
        presentationSmallTitle: "Your wedding in Camprodón",
        presentationTitle: "Hotel for weddings",
        presentationContent: <>{"Hotel Camprodon offers a unique setting for your wedding. Surrounded by nature and located in a historical building full of romanticism, "}<strong>your day will be just as you dreamed of</strong>.</>,
        fullSliderImgAlt: "Hotel for weddings",
        fullSliderImgAlt2: "Hotel for weddings",
        fullSliderImgAlt3: "Hotel for weddings",
        fullSliderImgAlt4: "Hotel for weddings",
        sectionHeadSubtitle: "Celebrate the wedding of your dreams",
        sectionHeadTitle: "Weddings at the Hotel Camprodon",
        sectionHeadTexts: "The large garden allows us to organize your outdoor ceremony as well as serving snacks, which can also be served on the terrace next to the river. You can choose from several wedding menus and choose the hall that you like most to host a banquet for up to 250 people.",
        sectionHeadTexts2: "Hotel Camprodon can organize your official and legal civil ceremony, because we work directly with the city council.",
        formTitle: "Do you want to celebrate your wedding at the Hotel Camprodon?",
        formContent: "Fill out this form and send us your request. We will contact you as soon as possible.",
        languageValue: "en",
        checkboxHref: "/en/privacy-policy",
    },
    fr: {
        heroImageAlt: "Mariages à l'Hotel Camprodon",
        heroSmallTitle: "Le mariage de vos rêves à Camprodon",
        heroTitle: "Mariages à l'Hotel Camprodon",
        presentationSmallTitle: "Votre mariage à Camprodon",
        presentationTitle: "Hôtel pour mariages",
        presentationContent: <>{"L'Hotel Camprodon vous offre un cadre incomparable pour votre mariage. Entouré de nature et situé dans un bâtiment historique empreint de romantisme, "}<strong>votre journée sera exactement telle que vous l'avez rêvée</strong>.</>,
        fullSliderImgAlt: "Hôtel pour mariages",
        fullSliderImgAlt2: "Hôtel pour mariages",
        fullSliderImgAlt3: "Hôtel pour mariages",
        fullSliderImgAlt4: "Hôtel pour mariages",
        sectionHeadSubtitle: "Célébrez le mariage de vos rêves",
        sectionHeadTitle: "Mariages à l'Hotel Camprodon",
        sectionHeadTexts: "Le grand jardin nous permet d'organiser votre cérémonie en plein air ainsi que de servir l'apéritif, qui peut aussi être servi sur la terrasse au bord de la rivière. Vous pourrez choisir entre plusieurs menus de mariage et la salle qui vous convient le mieux, d'une capacité allant jusqu'à 250 personnes.",
        sectionHeadTexts2: "À l'Hotel Camprodon, vous pourrez organiser votre cérémonie civile officielle, car nous disposons du registre civil de la mairie pour la célébrer.",
        formTitle: "Vous souhaitez célébrer votre mariage à l'Hotel Camprodon ?",
        formContent: "Remplissez ce formulaire et envoyez-nous votre demande. Nous vous contacterons dans les plus brefs délais.",
        languageValue: "fr",
        checkboxHref: "/fr/politique-de-confidentialite",
    },
    de: {
        heroImageAlt: "Hochzeiten im Hotel Camprodon",
        heroSmallTitle: "Die Hochzeit Ihrer Träume in Camprodon",
        heroTitle: "Hochzeiten im Hotel Camprodon",
        presentationSmallTitle: "Ihre Hochzeit in Camprodon",
        presentationTitle: "Hotel für Hochzeiten",
        presentationContent: <>{"Das Hotel Camprodon bietet Ihnen einen unvergleichlichen Rahmen für Ihre Hochzeit. Umgeben von Natur und in einem historischen, romantischen Gebäude gelegen, "}<strong>wird Ihr Tag genau so, wie Sie ihn sich erträumt haben</strong>.</>,
        fullSliderImgAlt: "Hotel für Hochzeiten",
        fullSliderImgAlt2: "Hotel für Hochzeiten",
        fullSliderImgAlt3: "Hotel für Hochzeiten",
        fullSliderImgAlt4: "Hotel für Hochzeiten",
        sectionHeadSubtitle: "Feiern Sie die Hochzeit Ihrer Träume",
        sectionHeadTitle: "Hochzeiten im Hotel Camprodon",
        sectionHeadTexts: "Im großen Garten können wir Ihre Zeremonie im Freien ausrichten und den Aperitif servieren, den wir auch auf der Terrasse am Fluss anbieten können. Sie können zwischen mehreren Hochzeitsmenüs und dem passenden Saal mit bis zu 250 Personen wählen.",
        sectionHeadTexts2: "Im Hotel Camprodon können Sie Ihre offizielle standesamtliche Trauung feiern, da wir über das Standesbuch der Gemeinde verfügen.",
        formTitle: "Möchten Sie Ihre Hochzeit im Hotel Camprodon feiern?",
        formContent: "Füllen Sie dieses Formular aus und senden Sie uns Ihre Anfrage. Wir melden uns so schnell wie möglich bei Ihnen.",
        languageValue: "de",
        checkboxHref: "/de/privacy-policy",
    },
    it: {
        heroImageAlt: "Matrimoni all'Hotel Camprodon",
        heroSmallTitle: "Il matrimonio dei tuoi sogni a Camprodon",
        heroTitle: "Matrimoni all'Hotel Camprodon",
        presentationSmallTitle: "Il tuo matrimonio a Camprodon",
        presentationTitle: "Hotel per matrimoni",
        presentationContent: <>{"L'Hotel Camprodon ti offre una cornice incomparabile per il tuo matrimonio. Immerso nella natura e situato in un edificio storico intriso di romanticismo, "}<strong>il vostro giorno sarà esattamente come l'avete sognato</strong>.</>,
        fullSliderImgAlt: "Hotel per matrimoni",
        fullSliderImgAlt2: "Hotel per matrimoni",
        fullSliderImgAlt3: "Hotel per matrimoni",
        fullSliderImgAlt4: "Hotel per matrimoni",
        sectionHeadSubtitle: "Celebra il matrimonio dei tuoi sogni",
        sectionHeadTitle: "Matrimoni all'Hotel Camprodon",
        sectionHeadTexts: "L'ampio giardino ci permette di organizzare la vostra cerimonia all'aperto e di servire l'aperitivo, che possiamo servire anche sulla terrazza lungo il fiume. Potrete scegliere tra diversi menù di nozze e la sala che preferite, con capienza fino a 250 persone.",
        sectionHeadTexts2: "All'Hotel Camprodon potrete celebrare il vostro matrimonio civile ufficiale, poiché disponiamo del registro civile del Comune per officiarlo.",
        formTitle: "Vuoi celebrare il tuo matrimonio all'Hotel Camprodon?",
        formContent: "Compila questo modulo e inviaci la tua richiesta. Ti contatteremo il prima possibile.",
        languageValue: "it",
        checkboxHref: "/it/informativa-sulla-privacy",
    },
    pt: {
        heroImageAlt: "Casamentos no Hotel Camprodon",
        heroSmallTitle: "O casamento dos seus sonhos em Camprodon",
        heroTitle: "Casamentos no Hotel Camprodon",
        presentationSmallTitle: "O seu casamento em Camprodon",
        presentationTitle: "Hotel para casamentos",
        presentationContent: <>{"O Hotel Camprodon oferece-lhe um cenário incomparável para o seu casamento. Rodeado de natureza e situado num edifício histórico impregnado de romantismo, "}<strong>o vosso dia será tal e qual o sonharam</strong>.</>,
        fullSliderImgAlt: "Hotel para casamentos",
        fullSliderImgAlt2: "Hotel para casamentos",
        fullSliderImgAlt3: "Hotel para casamentos",
        fullSliderImgAlt4: "Hotel para casamentos",
        sectionHeadSubtitle: "Celebre o casamento dos seus sonhos",
        sectionHeadTitle: "Casamentos no Hotel Camprodon",
        sectionHeadTexts: "O amplo jardim permite-nos organizar a vossa cerimónia ao ar livre, bem como servir os aperitivos, que também podemos servir no terraço junto ao rio. Poderão escolher entre vários menus de casamento e a sala que mais vos convier, com capacidade até 250 pessoas.",
        sectionHeadTexts2: "No Hotel Camprodon poderão organizar a vossa cerimónia civil oficial, pois dispomos do livro civil da Câmara Municipal para a realizar.",
        formTitle: "Quer celebrar o seu casamento no Hotel Camprodon?",
        formContent: "Preencha este formulário e envie-nos o seu pedido. Entraremos em contacto consigo o mais brevemente possível.",
        languageValue: "pt",
        checkboxHref: "/pt/politica-de-privacidade",
    },
    nl: {
        heroImageAlt: "Bruiloften in Hotel Camprodon",
        heroSmallTitle: "De bruiloft van je dromen in Camprodon",
        heroTitle: "Bruiloften in Hotel Camprodon",
        presentationSmallTitle: "Jouw bruiloft in Camprodon",
        presentationTitle: "Hotel voor bruiloften",
        presentationContent: <>{"Hotel Camprodon biedt een onvergelijkbaar decor voor jullie bruiloft. Omringd door natuur en in een historisch gebouw vol romantiek "}<strong>wordt jullie dag precies zoals jullie hem gedroomd hebben</strong>.</>,
        fullSliderImgAlt: "Hotel voor bruiloften",
        fullSliderImgAlt2: "Hotel voor bruiloften",
        fullSliderImgAlt3: "Hotel voor bruiloften",
        fullSliderImgAlt4: "Hotel voor bruiloften",
        sectionHeadSubtitle: "Vier de bruiloft van je dromen",
        sectionHeadTitle: "Bruiloften in Hotel Camprodon",
        sectionHeadTexts: "In de grote tuin kunnen we jullie ceremonie in de open lucht organiseren en het aperitief serveren, dat ook op het terras aan de rivier kan. Jullie kunnen kiezen uit verschillende bruiloftsmenu's en de zaal die het beste past, met plaats voor maximaal 250 personen.",
        sectionHeadTexts2: "In Hotel Camprodon kunnen jullie een officiële burgerlijke ceremonie houden, want we beschikken over het burgerlijk register van de gemeente.",
        formTitle: "Wil je je bruiloft vieren in Hotel Camprodon?",
        formContent: "Vul dit formulier in en stuur ons je aanvraag. We nemen zo snel mogelijk contact met je op.",
        languageValue: "nl",
        checkboxHref: "/nl/privacy-beleid",
    },
    cs: {
        heroImageAlt: "Svatby v hotelu Hotel Camprodon",
        heroSmallTitle: "Svatba vašich snů v Camprodonu",
        heroTitle: "Svatby v hotelu Hotel Camprodon",
        presentationSmallTitle: "Vaše svatba v Camprodonu",
        presentationTitle: "Hotel pro svatby",
        presentationContent: <>{"Hotel Camprodon vám nabízí jedinečné prostředí pro vaši svatbu. Obklopen přírodou a v historické budově plné romantiky "}<strong>bude váš den přesně takový, jaký jste si vysnili</strong>.</>,
        fullSliderImgAlt: "Hotel pro svatby",
        fullSliderImgAlt2: "Hotel pro svatby",
        fullSliderImgAlt3: "Hotel pro svatby",
        fullSliderImgAlt4: "Hotel pro svatby",
        sectionHeadSubtitle: "Oslavte svatbu svých snů",
        sectionHeadTitle: "Svatby v hotelu Hotel Camprodon",
        sectionHeadTexts: "Velká zahrada nám umožňuje uspořádat obřad pod širým nebem a podávat aperitiv, který můžeme podávat i na terase u řeky. Můžete si vybrat z několika svatebních menu a sál, který vám nejvíce vyhovuje, s kapacitou až 250 osob.",
        sectionHeadTexts2: "V hotelu Hotel Camprodon můžete uspořádat oficiální civilní obřad, protože máme k dispozici matriku obce.",
        formTitle: "Chcete oslavit svatbu v hotelu Hotel Camprodon?",
        formContent: "Vyplňte tento formulář a pošlete nám svou žádost. Ozveme se vám co nejdříve.",
        languageValue: "cs",
        checkboxHref: "/cs/zasady-ochrany-soukromí",
    },
    ru: {
        heroImageAlt: "Свадьбы в Hotel Camprodon",
        heroSmallTitle: "Свадьба вашей мечты в Кампродоне",
        heroTitle: "Свадьбы в Hotel Camprodon",
        presentationSmallTitle: "Ваша свадьба в Кампродоне",
        presentationTitle: "Отель для свадеб",
        presentationContent: <>{"Hotel Camprodon предлагает несравненную обстановку для вашей свадьбы. В окружении природы, в историческом здании, полном романтики, "}<strong>ваш день пройдёт именно так, как вы мечтали</strong>.</>,
        fullSliderImgAlt: "Отель для свадеб",
        fullSliderImgAlt2: "Отель для свадеб",
        fullSliderImgAlt3: "Отель для свадеб",
        fullSliderImgAlt4: "Отель для свадеб",
        sectionHeadSubtitle: "Отпразднуйте свадьбу своей мечты",
        sectionHeadTitle: "Свадьбы в Hotel Camprodon",
        sectionHeadTexts: "Большой сад позволяет провести церемонию под открытым небом и подать аперитив, который можно организовать и на террасе у реки. Вы сможете выбрать одно из нескольких свадебных меню и подходящий зал вместимостью до 250 человек.",
        sectionHeadTexts2: "В Hotel Camprodon можно провести официальную гражданскую церемонию: у нас есть книга регистрации муниципалитета.",
        formTitle: "Хотите отпраздновать свадьбу в Hotel Camprodon?",
        formContent: "Заполните эту форму и отправьте нам заявку. Мы свяжемся с вами в кратчайшие сроки.",
        languageValue: "ru",
        checkboxHref: "/ru/politika-otmeny",
    },
    sv: {
        heroImageAlt: "Bröllop på Hotel Camprodon",
        heroSmallTitle: "Drömbröllopet i Camprodon",
        heroTitle: "Bröllop på Hotel Camprodon",
        presentationSmallTitle: "Ditt bröllop i Camprodon",
        presentationTitle: "Hotell för bröllop",
        presentationContent: <>{"Hotel Camprodon erbjuder en enastående miljö för ert bröllop. Omgivet av natur och i en historisk byggnad full av romantik "}<strong>blir er dag precis som ni har drömt om</strong>.</>,
        fullSliderImgAlt: "Hotell för bröllop",
        fullSliderImgAlt2: "Hotell för bröllop",
        fullSliderImgAlt3: "Hotell för bröllop",
        fullSliderImgAlt4: "Hotell för bröllop",
        sectionHeadSubtitle: "Fira ditt drömbröllop",
        sectionHeadTitle: "Bröllop på Hotel Camprodon",
        sectionHeadTexts: "I den stora trädgården kan vi ordna vigseln utomhus och servera aperitifen, som också kan serveras på terrassen vid floden. Ni kan välja mellan flera bröllopsmenyer och den sal som passar er bäst, med plats för upp till 250 personer.",
        sectionHeadTexts2: "På Hotel Camprodon kan ni hålla en officiell borgerlig vigsel, eftersom vi har kommunens vigselregister.",
        formTitle: "Vill ni fira ert bröllop på Hotel Camprodon?",
        formContent: "Fyll i formuläret och skicka din förfrågan. Vi kontaktar dig så snart som möjligt.",
        languageValue: "sv",
        checkboxHref: "/sv/privacy-policy",
    },
};

export default textos;
